import { useEffect, useState } from "react";
import api, { formatErr } from "../../lib/api";
import { toast } from "sonner";
import { Percent } from "@/components/icons";

export default function AdminCommissions() {
  const [cfg, setCfg] = useState(null);
  useEffect(() => {
    api.get("/admin/commission-config").then((r) => setCfg(r.data));
  }, []);

  const save = async (e) => {
    e.preventDefault();
    try {
      const body = {
        platform_commission_pct: parseFloat(cfg.platform_commission_pct),
        doctor_share_pct: parseFloat(cfg.doctor_share_pct),
        platform_share_pct: parseFloat(cfg.platform_share_pct),
      };
      await api.put("/admin/commission-config", body);
      toast.success("Comisiones actualizadas");
    } catch (err) {
      toast.error(formatErr(err.response?.data?.detail));
    }
  };

  if (!cfg) return <div>Cargando…</div>;

  return (
    <div className="space-y-6" data-testid="admin-commissions">
      <div>
        <h1 className="text-3xl font-extrabold text-[#163144] tracking-tight">
          Comisiones de farmacia
        </h1>
        <p className="text-sm text-[#1B405B]/70 max-w-2xl">
          Configura el porcentaje total que la plataforma cobra a la farmacia
          por cada venta y cómo se reparte entre el doctor y la plataforma.
          La farmacia <b>nunca</b> ve la repartición — solo el porcentaje total.
        </p>
      </div>

      <form
        onSubmit={save}
        className="glass rounded-[28px] p-6 max-w-3xl space-y-5"
      >
        <div className="flex items-center gap-2 mb-1">
          <Percent className="w-5 h-5 text-[#1B405B]" />
          <h3 className="text-lg font-bold text-[#163144]">Configuración</h3>
        </div>

        <div className="grid sm:grid-cols-3 gap-4">
          <Field
            label="% Total a farmacia"
            value={cfg.platform_commission_pct}
            onChange={(v) =>
              setCfg({ ...cfg, platform_commission_pct: v })
            }
            id="commission-total-pct"
          />
          <Field
            label="% Doctor"
            value={cfg.doctor_share_pct}
            onChange={(v) => setCfg({ ...cfg, doctor_share_pct: v })}
            id="commission-doctor-pct"
          />
          <Field
            label="% Plataforma"
            value={cfg.platform_share_pct}
            onChange={(v) => setCfg({ ...cfg, platform_share_pct: v })}
            id="commission-platform-pct"
          />
        </div>

        <div className="bg-[#DBEAFE]/50 rounded-xl p-4 text-sm text-[#163144]">
          <b>Validación:</b> % Doctor + % Plataforma debe ser igual a % Total
          ({cfg.platform_commission_pct}%).
          Actualmente: {Number(cfg.doctor_share_pct) + Number(cfg.platform_share_pct)}%.
        </div>

        <button
          data-testid="save-commission-button"
          type="submit"
          className="btn-primary"
        >
          Guardar cambios
        </button>
      </form>

      <div className="glass rounded-[28px] p-6 max-w-3xl">
        <h3 className="text-lg font-bold text-[#163144] mb-2">
          Ejemplo práctico
        </h3>
        <p className="text-sm text-[#1B405B]/80">
          Si la farmacia vende una receta por <b>$100</b>:
        </p>
        <ul className="mt-2 text-sm space-y-1.5 text-[#163144]">
          <li>
            • La plataforma le cobra a la farmacia{" "}
            <b>${(100 * cfg.platform_commission_pct) / 100}</b> (
            {cfg.platform_commission_pct}%).
          </li>
          <li>
            • El doctor recibe internamente{" "}
            <b>${(100 * cfg.doctor_share_pct) / 100}</b> (
            {cfg.doctor_share_pct}%).
          </li>
          <li>
            • La plataforma se queda con{" "}
            <b>${(100 * cfg.platform_share_pct) / 100}</b> (
            {cfg.platform_share_pct}%).
          </li>
        </ul>
      </div>
    </div>
  );
}

function Field({ label, value, onChange, id }) {
  return (
    <div>
      <label className="text-xs font-bold uppercase tracking-wider text-[#1B405B]/70">
        {label}
      </label>
      <div className="mt-1 relative">
        <input
          data-testid={id}
          type="number"
          min="0"
          step="0.01"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className="w-full bg-white/60 rounded-xl px-4 py-3 border border-white/70 pr-9"
        />
        <span className="absolute right-3 top-1/2 -translate-y-1/2 text-[#1B405B]/60 font-bold">
          %
        </span>
      </div>
    </div>
  );
}
